import { observer } from "mobx-react";
import React from "react";

import { colors } from "@apps/viewer/src/ts/config";
import { injectStore, Store } from "@apps/viewer/src/ts/store";

type WrapperProps = {
  children: React.ReactNode;

  /**
   * A reference to the application lifecycle store, so we can update state
   * when needed.
   */
  store: Store;
};

/**
 * The wrapper will render the primary content area, which all page content is
 * going to be nested inside.
 */
@observer
class WrapperUnwrapped extends React.Component<WrapperProps> {
  /**
   * Main render method
   */
  public render(): React.JSX.Element {
    return (
      <main className={`${this.props.store.isMobile ? "mobile" : ""}`}>
        {this.props.children}

        <style jsx>{`
          main {
            overflow: hidden;

            /**
                        * Make sure that the block extends to fill the height
                        * of the viewport.
                        */
            min-height: 100vh;

            /** Fixate sizing of the block */
            width: 1120px;
            max-width: calc(100vw - 60px);

            /** Center the block horizontally */
            margin: 0 auto;

            /**
                        * Apply padding to prevent content from under-flowing
                        * the header / footer.
                        */
            box-sizing: border-box;
            padding: 117px 60px 108px;

            /** Apply box styling */
            background: ${colors.white};

            /** Apply font styling */
            line-height: 22px;

            /** generally allow breaking of long words in content */
            word-wrap: break-word;

            &.mobile {
              padding: 90px 15px 110px;
              max-width: calc(100vw - 30px);
            }
          }
        `}</style>
      </main>
    );
  }
}

// tslint:disable-next-line variable-name
export const Wrapper = injectStore(WrapperUnwrapped);
